import React from "react";

interface ProgressTableSkeletonProps {
  rows?: number;
}

const ProgressTableSkeleton: React.FC<ProgressTableSkeletonProps> = ({ rows = 5 }) => {
  return (
    <>
      {Array.from({ length: rows }).map((_, idx) => (
        <div
          key={idx}
          className="grid grid-cols-[2fr_1.2fr_1fr_1.2fr_1.2fr] items-center gap-3 border-t border-slate-100 px-4 py-3"
        >
          <div className="flex items-center gap-2">
            <div className="h-4 w-40 rounded bg-slate-200 animate-pulse" />
          </div>

          <div className="flex items-center gap-3">
            <div className="h-6 w-6 rounded-full bg-slate-200 animate-pulse" />
            <div className="h-4 w-10 rounded bg-slate-200 animate-pulse" />
          </div>

          <div className="text-right">
            <div className="ml-auto h-4 w-8 rounded bg-slate-200 animate-pulse" />
          </div>
          <div className="text-right">
            <div className="ml-auto h-4 w-8 rounded bg-slate-200 animate-pulse" />
          </div>
          <div className="text-right">
            <div className="ml-auto h-4 w-8 rounded bg-slate-200 animate-pulse" />
          </div>
        </div>
      ))}
    </>
  );
};

export default ProgressTableSkeleton;


